// Tour target IDs for batch details
export const BATCH_TOUR_IDS = {
  DETAILS_BLOCK: 'batch-details-block',
  BATCH_NUMBER: 'batch-number',
  BATCH_LINK: 'batch-link',
  READY_QUANTITY: 'ready-quantity',
  PRODUCTIVITY_STATUS_BLOCK: 'productivity-status-block',
  BATCH_STATUS_BLOCK: 'batch-status-block',
} as const;

// Demo IDs for batch tour - use 999998xxx range
export const DEMO_BATCH_ID = 999998001;
export const DEMO_MACHINE_ID = 999998999;
export const DEMO_NC_FILE_ID = 999998002;
export const DEMO_PART_ID = 999998003;
export const DEMO_OPERATION_ID = 999998004;
export const DEMO_ORDER_ID = 999998005;

// Legacy IDs for cleaning up old persisted data
export const LEGACY_DEMO_BATCH_ID = -9001;
export const LEGACY_DEMO_MACHINE_ID = -998;

// Threshold for identifying demo data
export const DEMO_ID_THRESHOLD = 999998000;
